/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type InstanceMcpServer = {
  /**
   * The address of the MCP server
   */
  url: string;
};

/** @internal */
export const InstanceMcpServer$inboundSchema: z.ZodMiniType<
  InstanceMcpServer,
  unknown
> = z.object({
  url: z.string(),
});

export function instanceMcpServerFromJSON(
  jsonString: string,
): SafeParseResult<InstanceMcpServer, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => InstanceMcpServer$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'InstanceMcpServer' from JSON`,
  );
}
